import type { LocationQuery, RouteParamsGeneric } from 'vue-router';
import {
  CLIENT_API_EXPERTS_OPINIONS_URL,
  CLIENT_API_NEWS_MATERIALS_URL,
  CLIENT_API_PREVIEW_BY_HASH_URL,
} from '~/shared/api/client/news/news.const';

/** Routes rendered by ArticlePage (see app/router.options.ts) */
export const ARTICLE_ROUTE_NAMES = ['news-id', 'news-preview'];

export interface IArticleRequest {
  url: string;
  key: string;
  isPreview: boolean;
}

interface IArticleRouteSource {
  params: RouteParamsGeneric;
  query: LocationQuery;
  path: string;
}

/**
 * URL and request key for the article page's article request. The request is
 * made by the partner-article.global middleware before the layout renders;
 * the page reads the result from the payload by the same key. That's why the
 * key doesn't include `?type=` — the first request's URL (with type validation
 * on the backend) and subsequent ones point to the same article.
 */
export const buildArticleRequest = (
  route: IArticleRouteSource,
  firstLoad: boolean,
): IArticleRequest | null => {
  const newsId = Number(route.params.id || route.query.id);

  if (!newsId) {
    return null;
  }

  if (route.query.hash) {
    return {
      url: `${CLIENT_API_PREVIEW_BY_HASH_URL}?id=${newsId}&hash=${route.query.hash}`,
      key: `article-preview:${newsId}:${route.query.hash}`,
      isPreview: true,
    };
  }

  const newsType = route.path.split('/', 2)[1];
  const isExpert = newsType === 'expert';
  const baseUrl = isExpert
    ? CLIENT_API_EXPERTS_OPINIONS_URL
    : CLIENT_API_NEWS_MATERIALS_URL;

  /*
    Мнение открывается по публичному номеру через by-expert-url — параметр
    type этой ручке не нужен, она и так отдаёт одну конкретную запись.
  */
  return {
    url: `${baseUrl}${newsId}/${!isExpert && firstLoad ? `?type=${newsType}` : ''}`,
    key: `article:${newsType}:${newsId}`,
    isPreview: false,
  };
};
